import { filter, get, map } from 'lodash';
import { CSSProperties, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CropStateType, elementBeanListType } from '../../../Pages/Flo/Flo.types';
import { calculateAspectRatioFit } from '../../../utils/video.utils';
import VideoBlurActive from '../VideoBlurActive/VideoBlurActive';

const defaultBlurs: elementBeanListType[] = [];

const VideoBlurs = ({
	currentTimeSeconds,
	videoSize = {
		width: 0,
		height: 0,
	},
	width: vWidth,
	height: vHeight,
	isCropped,
	appliedCrop,
	elementType,
	floIndex,
	stylesObj,
}: {
	currentTimeSeconds: number;
	videoSize?:
		| {
				width: number;
				height: number;
		  }
		| undefined
		| null;
	width: number;
	height: number;
	isCropped?: boolean;
	appliedCrop?: CropStateType;
	elementType?: string;
	floIndex: number;
	stylesObj?: CSSProperties;
}) => {
	const frameDims = calculateAspectRatioFit(
		get(videoSize, 'width', 0),
		get(videoSize, 'height', 0),
		vWidth,
		vHeight
	);
	const [blurs, setBlurs] = useState<elementBeanListType[]>([]);
	const offsetLeft = Math.abs(frameDims.width - vWidth) / 2;
	const offsetTop = (vHeight - frameDims.height) / 2;
	const elementsConfig: elementBeanListType[] = useSelector((state) =>
		get(state, `floPage.flos.${floIndex}.editorsElements.${elementType}`, defaultBlurs)
	);
	// const appliedCrop = useSelector((state) => {
	// 	return find(get(state, 'floPage.editorsElementsConfig'), [
	// 		'editorElementName',
	// 		'crop'
	// 	]);
	// })
	useEffect(() => {
		let blurElements = filter(
			elementsConfig,
			(element) =>
				// get(element, 'enabled') &&
				element.editorElementName === elementType &&
				currentTimeSeconds >= (get(element, 'time') ?? -1) &&
				currentTimeSeconds <= (get(element, 'endTime') ?? -1)
		);
		setBlurs(
			map(blurElements, (i) => ({
				id: get(i, 'id'),
				title: get(i, 'text'),
				enabled: get(i, 'enabled', true),
				startTime: get(i, 'time'),
				endTime: get(i, 'endTime'),
				intensity: get(i, 'intensity'),
				color: get(i, 'color'),
				shape: get(i, 'shape'),
				canvasRenderConfig: get(i, 'canvasRenderConfig'),
				aspectRatio: get(i, 'aspectRatio') || get(i, 'canvasRenderConfig.aspectRatio'),
			}))
		);
	}, [setBlurs, elementsConfig, currentTimeSeconds, appliedCrop]);

	return (
		<div
			style={{
				...(stylesObj || {}),
				position: 'absolute',
				width: vWidth,
				height: vHeight,
				overflow: 'hidden',
				pointerEvents: 'none',
			}}
		>
			{map(blurs, (blur) => (
				<VideoBlurActive
					key={get(blur, 'id')}
					width={vWidth}
					height={vHeight}
					offsetWidth={offsetLeft}
					offsetHeight={offsetTop}
					elementType={elementType}
					element={blur}
					isCropped={isCropped}
					// @ts-ignore
					appliedCrop={appliedCrop}
				/>
			))}
		</div>
	);
};

export default VideoBlurs;
